import { APIUrlConstants, AppConstants } from '../../../common/APIConstants';
import RestEndPoint from '../../../common/RestEndPoint';

export default class NGLTeamDailyReportAPI {
  static getScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.GetNGLTeamDailyReportData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,    //undo this and use method callAzureFunction while checking in
      data
    );
  }

  static saveScreenData(data) {
    return RestEndPoint.callAzureFunction(
      APIUrlConstants.SaveNGLTeamDailyReportData,
      'POST',
      AppConstants.APP_BACKEND_HOST_KEY,
      data
    );
  }
}
